import { useState } from 'react';
import Lightbox from '../../../components/ui/Lightbox/Lightbox';
import './ProjectFloorPlans.css';

export default function ProjectFloorPlans({ project }) {
  const plans = project.floorPlans || [];
  const [active, setActive] = useState(null);

  if (!plans.length) return null;

  return (
    <section className="pd-section pd-section--alt">
      <div className="pd-section__inner">
        <p className="pd-eyebrow">Floor Plans</p>
        <h2 className="pd-title">Layouts</h2>

        <div className="pd-fp__grid">
          {plans.map((plan, i) => (
            <div key={plan.unitType} className="pd-fp__item">
              <button
                className="pd-fp__img"
                onClick={() => setActive(i)}
                aria-label={`View floor plan: ${plan.unitType}`}
              >
                <img src={plan.image?.src || plan.image} alt={`${plan.unitType} floor plan`} loading="lazy" />
              </button>
              <div className="pd-fp__meta">
                <h3 className="pd-fp__type">{plan.unitType}</h3>
                <p className="pd-fp__specs">
                  {plan.bedrooms ? `${plan.bedrooms} Bed` : null}
                  {plan.bedrooms && plan.size ? ' · ' : null}
                  {plan.size || null}
                </p>
                {plan.description && <p className="pd-fp__desc">{plan.description}</p>}
              </div>
            </div>
          ))}
        </div>

        <Lightbox
          items={plans.map((p) => ({
            src: p.image?.src || p.image,
            alt: `${p.unitType} floor plan`,
            caption: p.unitType,
          }))}
          index={active}
          onClose={() => setActive(null)}
          onNavigate={setActive}
        />
      </div>
    </section>
  );
}
